import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Legend, Series, Size } from "devextreme-react/pie-chart";
import { AprEtsTabE as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEtsTabE = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const tenThirteenField = () => {
    const propertyName = pn<AprResponseModel>("tenThirteen");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.tenThirteen} {formatPercentTotal(props.data?.tenThirteen, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const fourteenEighteenField = () => {
    const propertyName = pn<AprResponseModel>("fourteenEighteen");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.fourteenEighteen} {formatPercentTotal(props.data?.fourteenEighteen, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const nineteenTwentySevenField = () => {
    const propertyName = pn<AprResponseModel>("nineteenTwentySeven");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.nineteenTwentySeven} {formatPercentTotal(props.data?.nineteenTwentySeven, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const twentyEightAboveField = () => {
    const propertyName = pn<AprResponseModel>("twentyEightAbove");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.twentyEightAbove} {formatPercentTotal(props.data?.twentyEightAbove, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const unknownField = () => {
    const propertyName = pn<AprResponseModel>("unknownAge");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.unknownAge} {formatPercentTotal(props.data?.unknownAge, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>
        {props.totalTabA != props.data?.totalParticipants && (
          <Typography color="error" variant="caption">
            Your Total Participants does not equal Total Participants in section A
          </Typography>
        )}
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Participant Distribution by Age</Typography>
        <Grid container spacing="lg">
          <Grid item xs={6}>
            <Grid container spacing="lg">
              <Grid item xs={12}>
                {tenThirteenField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {fourteenEighteenField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {nineteenTwentySevenField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {twentyEightAboveField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {unknownField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>

          <GridBreak />

          <Grid item xs={6}>
            <PieChart id="pie-tab-e" dataSource={props.data?.chartValues} palette="Bright" title="Participants" width="100%">
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid>
          
        </Grid>
      </Stack>
    </Card>
  );
};
